import { EnvConfig } from "@/types";
import { createContext } from "@lit/context";

export const envContext = createContext<EnvConfig | null>("sb:env");
